<template>
    <i ref="icon"></i>
</template>

<script>
    export default {
        props: {
            color: {
                default: '#fff'
            },
            size: {
                default: 20
            }
        },
        mounted() {
            Object.assign(this.$refs.icon.style,{
                "font-size": this.size + 'px',
                color: this.color
            });
        }
    }
</script>

<style scoped lang="scss">
    @font-face {
        font-family: Intelliboard;
        font-style: normal;
        font-weight: normal;
        src: url('../../fonts/intelliboard/intelliboard.eot');
        src: url('../../fonts/intelliboard/intelliboard.eot#iefix') format('embedded-opentype'),
        url('../../fonts/intelliboard/intelliboard.woff') format('woff'),
        url('../../fonts/intelliboard/intelliboard.ttf') format('truetype'),
        url('../../fonts/intelliboard/intelliboard.svg') format('svg');
    }

    i, ion-icon {
        &:before {
            content: "\E000";
        }
        &:after, &:before {
            font-family: Intelliboard;
            font-style: normal;
            margin-left: 0;
        }
    }
</style>
